import Swal from "sweetalert2";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxLimeStone } from "../../Limestone/AxLimeStone";
import { AxProgressBar } from "../../Limestone/AxProgressBar/AxProgressBar";
import { ProgressBarActiveStepEnum } from "./MainGiftCards";
import { ProgressBar } from "./ProgressbarGiftCards";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { PriceHelper } from "../../Lib/Helper/PriceHelper";
import { AxDropdown } from "@axess/limestone";

@ModuleName("PersonalizeGiftCard")
export class PersonalizeGiftCard implements AxInit {
    private initData: AxGiftCardsPersonalizeInit;
    public selectedGIftCardTypeId: number = 0;
    public PostUrl: string;
    private validationError: string;
    public priceHelper: PriceHelper;
    private quantityPicker: AxDropdown = new AxDropdown();

    constructor(
        private _ProgressBarGiftCards = new ProgressBar(),
        private _AxProgressBar = new AxProgressBar(),
        private _AxLimestone = new AxLimeStone(),
        private _I18nHelper = new I18nHelper(),
    ) { }

    AxInit(init: AxGiftCardsPersonalizeInit): void {
        this.initData = init;
        this.PostUrl = init.PostURL;
        this.priceHelper = new PriceHelper(init.CultureInfo, false);

        this.quantityPicker.init('#GiftCard__Quantity',
            {
                searchBar: false,
                multiSelect: false,
                onSelect: ($parent, value) => {
                    let quantity = parseInt(value as string);
                    $('.giftCards__personalization-count').html(value as string);
                    $('.giftcard__priceholder').html(this.priceHelper.GetPriceString(this.initData.Amount * quantity / 100));
                }
            });


        let steps = this._ProgressBarGiftCards.GetGiftCardSteps();
        if (this.initData.ProgressBarActiveStep == ProgressBarActiveStepEnum.AmountDesign) {
            steps[0].type = "active";
        } else {
            steps[0].type = "done";
            steps[1].type = "active";
        }
        this._AxProgressBar.Init({
            target: '.GiftCards__progressbar',
            steps: steps
        });
        this.AppendClickActions();
        this.AppendGiftCardMessageValidator();

        $('.giftcard__priceholder').html(this.priceHelper.GetPriceString(this.initData.Amount / 100));
    }

    AddToCart() {
        let quantity: string = this.quantityPicker.getValue() as string;
        let retailItemNr: string = $("#GiftCard__RetailItemNr").val().toString();
        let tariff: string = $("#GiftCard__Tariff").val().toString();
        let giftCard = {
            Email: $("#GiftCard__Email").val(),
            From: $("#GiftCard__From").val(),
            To: $("#GiftCard__To").val(),
            Message: $("#GiftCard__Message").val(),
            ImageLocation: this.initData.HeaderImageLocation,
            Quantity: parseInt(quantity),
            Tariff: parseFloat(tariff),
            RetailItemNr: parseInt(retailItemNr),
        };
        if (this.ValidateGiftCardInputs()) {
            AxessViewer.loadPartialView(this.initData.PostURL, giftCard, (result) => {
                if (result.success) {
                    AxLoad.LoadModule('AxFireShoppingCartModal', {
                        result: result,
                        continueShoppingPath: 'GiftCards',
                        btn: '.GiftCardPersonalize__AddToCart',
                        ResetQuantity: null
                    });
                } else {
                    Swal.fire({
                        title: this._I18nHelper.GetTranslation(Translations.Error),
                        icon: 'warning',
                        html: result.errorMessage,
                        customClass: {
                            closeButton: 'btn btn-secondary',
                            confirmButton: 'btn btn-primary',
                        },
                        confirmButtonText: this._I18nHelper.GetTranslation(Translations.Ok),
                    });
                }
                this.UnLockButtons();
            }, {
                silent: true,
            });
        }
        else {
            this.ShowErrorPopup();
        }
    }

    ShowErrorPopup() {
        Swal.fire({
            title: this._I18nHelper.GetTranslation(Translations.Error),
            icon: 'warning',
            html: this.validationError
        }).then(() => {
            this.UnLockButtons();
        });
    }

    UnLockButtons() {
        let btnContinueMobile = $(".GiftCardPersonalize__AddToCart").last() as unknown as HTMLElement;
        let btnContinueDesktop = $(".GiftCardPersonalize__AddToCart").first() as unknown as HTMLElement;
        let btnGoBackMobile = $(".GiftCardPersonalize__AddToCart").last() as unknown as HTMLElement;
        let btnGoBackDesktop = $(".GiftCardPersonalize__AddToCart").first() as unknown as HTMLElement;
        this._AxLimestone.UnlockButton(btnContinueMobile);
        this._AxLimestone.UnlockButton(btnGoBackMobile);
        this._AxLimestone.UnlockButton(btnContinueDesktop);
        this._AxLimestone.UnlockButton(btnGoBackDesktop);
    }

    LockButtons() {
        let btnContinueMobile = $(".GiftCardPersonalize__AddToCart").last() as unknown as HTMLElement;
        let btnContinueDesktop = $(".GiftCardPersonalize__AddToCart").first() as unknown as HTMLElement;
        let btnGoBackMobile = $(".GiftCardPersonalize__AddToCart").last() as unknown as HTMLElement;
        let btnGoBackDesktop = $(".GiftCardPersonalize__AddToCart").first() as unknown as HTMLElement;
        this._AxLimestone.LockButton(btnContinueMobile);
        this._AxLimestone.LockButton(btnGoBackMobile);
        this._AxLimestone.LockButton(btnContinueDesktop);
        this._AxLimestone.LockButton(btnGoBackDesktop);
    }

    ValidateGiftCardInputs(): boolean {
        let success = true;
        let recipientEmail = $("#GiftCard__Email").val().toString();
        let from = $("#GiftCard__From").val().toString();
        let to = $("#GiftCard__To").val().toString();
        let message = $("#GiftCard__Message").val().toString();
        this.validationError = "";
        if (!this.ValidateEmail(recipientEmail)) {
            this.validationError += this._I18nHelper.GetTranslation(Translations.ValidationMail) + '<br />';
            success = false;
        }
        if (from.length == 0) {
            let fromStr = this._I18nHelper.GetTranslation(Translations.From);
            this.validationError += this._I18nHelper.GetTranslation(Translations.FeldErforderlich, fromStr) + '<br />';
            success = false;
        }
        if (to.length == 0) {
            let toStr = this._I18nHelper.GetTranslation(Translations.To);
            this.validationError += this._I18nHelper.GetTranslation(Translations.FeldErforderlich, toStr) + '<br />';
            success = false;
        }
        if (message.length == 0) {
            let messageStr = this._I18nHelper.GetTranslation(Translations.Message);
            this.validationError += this._I18nHelper.GetTranslation(Translations.FeldErforderlich, messageStr) + '<br />';
            success = false;
        }
        return success;
    }

    ValidateEmail(email) {
        const re = new RegExp("([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\"\(\[\]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\[[\t -Z^-~]*])");
        return re.test(String(email).toLowerCase());
    }

    AppendClickActions() {
        $('.GiftCardPersonalize__AddToCart').click(x => {
            this.LockButtons();
            this.AddToCart();
        });
    }

    AppendGiftCardMessageValidator() {
        $('#GiftCard__Message').val("");
        const maxLength = 500;
        let oldLength = 0;
        let oldString = "";
        $(".giftCard_areaCounter").html(`0/${maxLength}`);
        $('#GiftCard__Message').keydown(x => {
            oldLength = $('#GiftCard__Message').val().toString().length;
            oldString = $('#GiftCard__Message').val().toString();
            if (oldLength == maxLength && (x.keyCode != 8 && x.keyCode != 46)) {
                x.preventDefault();
                return false;
            }
        });
        $('#GiftCard__Message').keyup(x => {
            let currentLength = $('#GiftCard__Message').val().toString().length;
            //workaround for paste
            if (currentLength > maxLength) {
                $('#GiftCard__Message').val(oldString);
                currentLength = $('#GiftCard__Message').val().toString().length;
            }
            $(".giftCard_areaCounter").html(`${currentLength}/${maxLength}`);
        });
    }

}
export interface AxGiftCardsPersonalizeInit {
    ProgressBarActiveStep: ProgressBarActiveStepEnum;
    PostURL: string;
    HeaderImageLocation: string;
    CultureInfo: any;
    Amount: number
}